export default __webpack_public_path__ + "static/dotcomm-58e42602a0372fd44ce054239f861a0a.svg";